import React from "react";

import ProjectsTable from "./ProjectsTable/ProjectsSettingsTable";

function ProjectSettings({ path }) {
  return <ProjectsTable path={path} />;
}

export default ProjectSettings;
